import React from "react";
import { HashLink } from "react-router-hash-link";

const OffersPage = () => {
  const hotDeals = [
    {
      name: "Spotify",
      price: "14,99€",
      logo: "https://upload.wikimedia.org/wikipedia/commons/2/26/Spotify_logo_with_text.svg",
    },
    {
      name: "Figma",
      price: "9,99€",
      logo: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
    },
    {
      name: "iCloud",
      price: "2,99€",
      logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    },
  ];

  const trending = [
    {
      name: "YouTube Premium",
      price: "11,99€",
      logo: "https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_Logo_2017.svg",
    },
    {
      name: "Amazon Prime",
      price: "8,99€",
      logo: "https://www.consumatori.it/wp-content/uploads/2022/06/amazon-ecommerce-1.png",
    },
    {
      name: "Notion",
      price: "4,99€",
      logo: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Notion-logo.svg",
    },
    {
      name: "HBO Max",
      price: 15.99,
      logo: "https://upload.wikimedia.org/wikipedia/commons/1/17/HBO_Max_Logo.svg",
    },
    {
      name: "LinkedIn",
      logo: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Linkedin.svg",
      price: 39.99,
    },
  ];

  const categories = [
    "Video",
    "Wellness",
    "Hobby",
    "Storage",
    "Work",
    "Learning",
    "Mobile",
    "Reading",
    "Music",
  ];

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <HashLink className="text-blue-500 text-sm" to="/demo">
          Back
        </HashLink>
        <h1 className="text-lg font-bold text-blue-500">Offers</h1>
        <button className="text-blue-500 text-sm">?</button>
      </div>

      {/* Hot Deals Section */}
      <div className="mb-6">
        <h2 className="text-blue-500 text-md font-bold mb-4">Hot Deals</h2>
        <div className="flex gap-4 overflow-x-auto">
          {hotDeals.map((deal, index) => (
            <div
              key={index}
              className="bg-blue-100 rounded-lg p-4 flex-shrink-0 w-28"
            >
              <img
                src={deal.logo}
                alt={deal.name}
                className="h-12 w-12 mx-auto mb-2"
              />
              <p className="text-center text-sm font-bold">{deal.name}</p>
              <p className="text-center text-sm text-gray-600">{deal.price}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Trending Section */}
      <div className="mb-6">
        <h2 className="text-blue-500 text-md font-bold mb-4">Trending</h2>
        <div className="flex gap-4 overflow-x-auto">
          {trending.map((deal, index) => (
            <div
              key={index}
              className="bg-blue-100 rounded-lg p-4 flex-shrink-0 w-28"
            >
              <img
                src={deal.logo}
                alt={deal.name}
                className="h-12 w-12 mx-auto mb-2"
              />
              <p className="text-center text-sm font-bold">{deal.name}</p>
              <p className="text-center text-sm text-gray-600">{deal.price}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Categories Section */}
      <div>
        <h2 className="text-blue-500 text-md font-bold mb-4">Categories</h2>
        <div className="flex flex-wrap gap-2">
          {categories.map((category, index) => (
            <button
              key={index}
              className="px-4 py-2 border border-blue-500 text-blue-500 rounded-full text-sm"
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OffersPage;
